export const NotifyType = {
    Activity: "Activity",
    Warning: "Warning",
    Error: "Error"
};
